import * as React from 'react'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import TimesheetButtons from 'modules/attendance/components/ClockIn/AdminLayout/WeeklyView/TimesheetButtons'

interface Props {
  showHourBalance: boolean
  isDaily: boolean
}
const HourlyBodyHeader = ({ showHourBalance, isDaily }: Props) => {
  const { employee } = useCurrentSession()
  return employee ? (
    <TimesheetButtons
      employeeId={employee.id}
      showHourBalance={showHourBalance}
      isDaily={isDaily}
    />
  ) : null
}

export default observer(HourlyBodyHeader)
